import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from 'store';
import { createActionDispatcher } from 'store/create-action-dispatcher';
import { fetcher } from 'utils/axios';

interface UnreadCounts {
  allUnreadCount: number;
  myUnreadCount: number;
  notMyUnreadCount: number;
  noAssigneeUnreadCount: number;
  botActiveUnreadCount: number;
}

const initialState: UnreadCounts = {
  allUnreadCount: 0,
  myUnreadCount: 0,
  notMyUnreadCount: 0,
  noAssigneeUnreadCount: 0,
  botActiveUnreadCount: 0,
};

const unreadChatUsersSlice = createSlice({
  name: 'unreadChatUsers',
  initialState,
  reducers: {
    storeSetUnreadChatUsers: (state, action: PayloadAction<UnreadCounts>) => {
      return action.payload;
    },
    storeClearUnreadChatUsers: () => {
      return initialState;
    },
  },
});

export default unreadChatUsersSlice.reducer;
export const { storeSetUnreadChatUsers, storeClearUnreadChatUsers } = unreadChatUsersSlice.actions;

export const setUnreadChatUsers = createActionDispatcher(storeSetUnreadChatUsers);
export const getUnreadChatUsers = async () => {
  try {
    const data = await fetcher('get', '/api/services/getUnreadChatUsers', 'api');
    if (data) {
      dispatch(
        storeSetUnreadChatUsers({
          allUnreadCount: data.allUnreadCount || 0,
          myUnreadCount: data.myUnreadCount || 0,
          notMyUnreadCount: data.notMyUnreadCount || 0,
          noAssigneeUnreadCount: data.noAssigneeUnreadCount || 0,
          botActiveUnreadCount: data.botActiveUnreadCount || 0,
        }),
      );
    }
  } catch (error) {
    console.warn('Error fetching chat users:', error);
  }
};
export const clearUnreadChatUsers = createActionDispatcher(storeClearUnreadChatUsers);
